/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-debugger */

import React, { FC, useEffect, useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { Autocomplete } from '@material-ui/lab';
import TextField from '@material-ui/core/TextField';
import { getSupervisorsOnly } from 'services/regions';
import { uniqBy } from 'lodash';

const useStyles = makeStyles({
  warning: {
    fontSize: '40px',
    color: '#e6005a',
    marginTop: 20,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
  },
  buttonConfirmCancel: {
    marginLeft: '10px',
    height: '40px',
    color: 'white',
  },
  purchaseDeleteTitle: {
    fontSize: '20px',
  },
  underline: {
    textDecoration: 'underline',
  },
});

type SupervisorsModalProps = {
  open: boolean;
  onClose(): void;
  regionId: string;
  dataProvider: any;
  unselectAll: any;
  notify: any;
  refresh: any;
  selectedIds: any[];
};

export const SupervisorsModal: FC<SupervisorsModalProps> = ({
  open,
  onClose,
  regionId,
  dataProvider,
  unselectAll,
  notify,
  refresh,
  selectedIds,
}) => {
  const classes = useStyles();
  const [supervisors, setSupervisors] = useState<any>([]);
  const [selectedSupervisors, setSelectedSupervisors] = useState<any>([]);

  const callGetSupervisors = async () => {
    const response = await getSupervisorsOnly({ regionId });
    const sorted = response.data.data.sort((a, b) =>
      a.firstName < b.firstName ? -1 : 1,
    );
    setSupervisors(sorted);
  };

  useEffect(() => {
    if (open && regionId) {
      callGetSupervisors();
    }
  }, [open]);

  const submitSupervisors = async () => {
    try {
      const replace = selectedIds.map(item => ({
        subdivisionId: item,
        userIds: selectedSupervisors.map(user => user.id),
      }));
      await dataProvider.create('subdivision-supervisor/batch-process', {
        data: {
          replace,
        },
      });
      notify('Element updated.');
      refresh();

      unselectAll('subdivision');
    } catch (error: any) {
      const errors = error.response.data.message;
      notify(
        errors || 'Failed to update Supervisors. Please try again.',
        'warning',
      );
    } finally {
      // setOpen(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="xs"
      fullWidth
    >
      <DialogContent className={classes.content}>
        <Typography className={classes.purchaseDeleteTitle}>
          Change Supervisor
        </Typography>
        <Box display="flex" alignItems="center" mt="10px">
          <Autocomplete
            fullWidth
            multiple
            getOptionLabel={option => (option ? option?.name : '')}
            renderInput={params => (
              <TextField {...params} label="Supervisors" />
            )}
            options={supervisors.map(item => ({
              name: `${item.firstName} ${item.lastName}`,
              id: item.id,
            }))}
            value={selectedSupervisors}
            onChange={(_event, value, _reason, _details) => {
              const uniqValues = uniqBy(value, item => item.id);

              setSelectedSupervisors(uniqValues);
            }}
          />
        </Box>
        <Box px={1} mt={2} textAlign="center">
          <Typography>
            Note: Be sure to select all Supervisors you want attached — this
            will replace the existing list, not add to it.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Box
          width="100%"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          paddingX="20px"
          paddingY="20px"
        >
          <Button onClick={onClose} style={{ color: 'red' }}>
            Cancel
          </Button>
          <Button
            onClick={submitSupervisors}
            color="primary"
            variant="contained"
            className={classes.buttonConfirmCancel}
            disabled={selectedSupervisors.length === 0}
          >
            Confirm
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};
